<template>
  <div class="animated fadeIn step-container">
      <div class="col-md-8 offset-md-2">
        <h2>{{$t('message.clinic.step_title')}}</h2>
        <step-bar :currentStep="currentStepNumber" :maxStep="5" @step_clicked="gotoStep">
          <div slot='1'>{{$t('message.clinic.step_info')}}</div>
          <div slot='2'>{{$t('message.clinic.step_address')}}</div>
          <div slot='3'>{{$t('message.clinic.step_schedule')}}</div>
          <div slot='4'>{{$t('message.clinic.step_services')}}</div>
          <div slot='5'>{{$t('message.clinic.step_doctors')}}</div>
        </step-bar>
      </div>

      <div class="component-wrapper" v-if="clinicReady">
        <component v-bind:is="currentStep" :clinic.sync="clinic" @finishStep="finishStep" @cancelChange="cancelChange"></component>
      </div>

      <sweet-modal icon="success" ref="modal">
        <h2>{{$t('message.clinic.create_clinic_success')}}</h2>
      </sweet-modal>

  </div>
</template>

<script>
import StepBar from '@/components/StepBar'
import BasicInfo from '@/pages/clinic/steps/General'
import AddressInfo from '@/pages/clinic/steps/Address'
import ScheduleInfo from '@/pages/clinic/steps/Schedules'
import ServiceInfo from '@/pages/clinic/steps/Services'
import DoctorInfo from '@/pages/clinic/steps/Doctors'
import { SweetModal } from 'sweet-modal-vue'
import router from '@/router'

export default {
  components: {
    SweetModal,
    StepBar,
    'step1': BasicInfo,
    'step2': AddressInfo,
    'step3': ScheduleInfo,
    'step4': ServiceInfo,
    'step5': DoctorInfo
  },
  data () {
    return {
      currentStep: 'step1', // track step
      stepOrder: ['step1', 'step2', 'step3', 'step4', 'step5'],
      lastStep: 'step5',
      clinic: {
        en: {},
        th: {},
        images: [],
        schedules: []
      },
      clinicReady: false
    }
  },
  methods: {
    gotoStep (s) {
      router.push({path: `/clinic/steps/step${s + 1}`})
    },
    cancelChange () {
      this._prevStep()
    },
    finishStep (clinicDataChanged) {
      if (clinicDataChanged) {
        this.$http.put(this.$APP_CONFIG.api.admin.clinicme(),
          // data
          clinicDataChanged,
          // options
          {
            credentials: true,
            headers: { 'content-type': 'application/json' }
          }).then(res => {
            if (res.body.status === 'success') {
              this.$toastr.success('Update Successful')
              this._nextStep()
            }
          })
      } else {
        // nothing to update
        // last step
        if (this.currentStep === this.lastStep) {
          let gotoNextStepTimeout = 1500
          this.$refs.modal.open()
          setTimeout(() => {
            this.$refs.modal.close()
            this._nextStep()
          }, gotoNextStepTimeout)
        } else {
          this._nextStep()
        }
      }
    },
    _nextStep () {
      var i = this.stepOrder.indexOf(this.currentStep) + 1
      if (i < this.stepOrder.length) {
        this.$router.replace('/clinic/steps/' + this.stepOrder[i])
        // this.$route.params.step = this.stepOrder[i]
      } else if (i === this.stepOrder.length) {
        this.$router.replace('/clinic/general')
      }
    },
    _prevStep () {
      var i = this.stepOrder.indexOf(this.currentStep) - 1
      if (i >= 0) {
        this.$router.replace('/clinic/steps/' + this.stepOrder[i])
      } else {
        this.$router.replace('/clinic/steps/' + this.stepOrder[0])
      }
    }
  },
  computed: {
    currentStepNumber () {
      return +this.currentStep.slice(this.currentStep.length - 1)
    }
  },
  created () {
    var self = this
    // update current step
    let _step = this.$route.params.step || 'step1'
    this.currentStep = _step.toLowerCase()

    this.$http.get(this.$APP_CONFIG.api.admin.clinicme(), { credentials: true }).then(res => {
      self.clinic = Object.assign({}, self.clinic, res.body.data)

      if (!self.clinic.th.video_links) {
        self.clinic.th.video_links = []
      }
      if (!self.clinic.en.video_links) {
        self.clinic.en.video_links = []
      }
      self.clinicReady = true
    }, errorResponse => {
      console.error(errorResponse)
    })
  },
  watch: {
    '$route' (to, from) {
      let _step = this.$route.params.step || 'step1'
      this.currentStep = _step.toLowerCase()
    }
  }
}
</script>

<style lang="sass">
@import "../../../assets/base_container";
</style>



// WEBPACK FOOTER //
// Clinic.vue?8a3012be